// Copyright (c) 2021 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const SubmitButton = props =>
    <section className='submit-request'>
        <button
            className='button-primary'
            disabled={props.isSubmitDisabled}
            onClick={props.onClick}
        >
            <FormattedMessage id='SUBMIT_REQUEST'/>
        </button>
    </section>;

SubmitButton.displayName = 'SubmitButton';
SubmitButton.propTypes = {
    isSubmitDisabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};
export default SubmitButton;



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/components/submit-button.js